// utils/kdsTransformer.js
/**
 * Transform API response (grouped by product) into internal order format
 * API structure: Array of products with items array
 * Internal format: Array of orders with items array
 */

export function transformApiResponseToOrders(apiResponse) {
  const ordersMap = new Map();

  const items = apiResponse?.items || [];

  items.forEach((item) => {
    const orderId = item.orderRefNumber; // use ref as unique order key

    if (!ordersMap.has(orderId)) {
      ordersMap.set(orderId, {
        id: item.orderRefNumber,
        orderId: item.orderRefNumber,
        table: item.tableName,
        type: mapTableToType(item.tableName),
        createdAt: item.orderCreatedAt,
        items: [],
      });
    }

    const order = ordersMap.get(orderId);

    order.items.push({
      orderDetailId: item.orderDetailId,
      productName: item.productName?.trim(),
      quantity: item.quantity,
      station: mapProductToStation(item.productName),

      orderItemStatus: item.orderItemStatus,
      preparedAt: item.preparedAt,
      preparedDurationSeconds: item.preparedDurationSeconds,
      servedAt: item.servedAt,
      servedDurationSeconds: item.servedDurationSeconds,
    });
  });

  return Array.from(ordersMap.values());
}

/**
 * Map table name to order type
 */
function mapTableToType(tableName) {
  const name = tableName.toLowerCase();
  if (name.includes("takeout") || name.includes("counter")) return "Takeout";
  if (name.includes("delivery")) return "Delivery";
  return "Dine-in"; // Default
}

/**
 * Map product name to station/area in kitchen
 * Customize based on your actual kitchen layout
 */
function mapProductToStation(productName) {
  const name = productName.toLowerCase();

  // Common food categories
  if (name.includes("burger") || name.includes("grill")) return "Grill";
  if (name.includes("pasta") || name.includes("spaghetti")) return "Pasta";
  if (name.includes("pizza")) return "Pizza";
  if (name.includes("fry") || name.includes("fried")) return "Fryer";
  if (name.includes("salad") || name.includes("cold")) return "Cold";
  if (name.includes("momo")) return "Steamer";
  if (name.includes("chowmein") || name.includes("noodle")) return "Wok";
  if (name.includes("rice") || name.includes("biryani")) return "Rice";
  if (name.includes("curry") || name.includes("dal")) return "Curry";

  return "Prep"; // Default station
}

/**
 * Calculate elapsed time in seconds from orderCreatedAt to now
 */
export function calculateElapsedSeconds(createdAtString) {
  const createdAt = new Date(createdAtString);
  const now = new Date();
  return Math.floor((now - createdAt) / 1000);
}

/**
 * Get unique stations from orders
 */
export function getStationsFromOrders(orders) {
  const stations = new Set(["All"]);
  orders.forEach((order) => {
    order.items.forEach((item) => {
      if (item.station) {
        stations.add(item.station);
      }
    });
  });
  return Array.from(stations);
}